import { Breadcrumb, Layout, Spin, Form, Input, Button, Row, Col, Card, Switch, message, Select, InputNumber } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Headerdiv from '../../layout/header';
import Footerdiv from '../../layout/footer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axiosClient from '../../../api/axiosClient';
import { APPBACKGROUND_COLOR } from '../../appsettings';

const { TextArea } = Input;

const EditSalesItem = () => {
    const [form] = Form.useForm();
    const { id } = useParams();
    const USERID = localStorage.getItem("USERID");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const fetchItemById = async () => {
        if (!id) return;
        setLoading(true);
        try {
            const response = await axiosClient.get(`/sales/get_sales_item_by_id.php?id=${id}`);
            const result = response.data;
            if (result.status === "success") {
                const item = result.data;
                form.setFieldsValue({
                    sp_code: item.sp_code,
                    sp_title: item.sp_title,
                    sp_desc: item.sp_desc,
                    sp_type: item.sp_type,
                    sp_duration: item.sp_duration,
                    sp_uprice: item.sp_uprice,
                    sp_active: item.sp_active
                });
            } else {
                message.error(result.message || 'Failed to fetch sales item.');
            }
        } catch (error) {
            console.error('Fetch item error:', error);
            message.error(error.response?.data?.message || 'Network error.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchItemById();
    }, [id]);

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            target_id: id,
            sp_title: values.sp_title,
            sp_desc: values.sp_desc || '',
            sp_type: values.sp_type,
            sp_duration: values.sp_duration,
            sp_uprice: values.sp_uprice || 0,
            sp_active: values.sp_active ? true : false,
            update_by: USERID
        };

        try {
            const response = await axiosClient.post('/sales/update_sales_item_by_id.php', payload);
            const data = response.data;
            if (data.status === "success") {
                message.success(data.message);
                navigate('/sales/items');
            } else {
                message.error(data.message || "Failed to update sales item.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Saving Sales Item...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item><Link to={"/sales/items"}>Sales</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Edit Sales Item</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Card title="Sales Item Information">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_code"
                                        label="Code"
                                        rules={[{ required: true, message: "Code is required" }]}
                                    >
                                        <Input placeholder="Enter Code" disabled />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_title"
                                        label="Title"
                                        rules={[
                                            { required: true, message: "Title is required" },
                                            { max: 200, message: "Title cannot exceed 200 characters" }
                                        ]}
                                    >
                                        <Input placeholder="Enter Title" maxLength={200} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_type"
                                        label="Type"
                                        rules={[{ required: true, message: "Type is required" }]}
                                    >
                                        <Select placeholder="Select Type">
                                            <Select.Option value="ITEM">Item</Select.Option>
                                            <Select.Option value="PACKAGE">Package</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_duration"
                                        label="Duration"
                                        rules={[{ required: true, message: "Duration is required" }]}
                                    >
                                        <Select placeholder="Select Duration">
                                            <Select.Option value="ONETIME">One Time</Select.Option>
                                            <Select.Option value="DAILY">Daily</Select.Option>
                                            <Select.Option value="MONTHLY">Monthly</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="sp_uprice"
                                        label="Price (Rs.)"
                                        rules={[{ required: true, message: "Price is required" }]}
                                    >
                                        <InputNumber 
                                            style={{ width: '100%' }}
                                            placeholder="Enter Price" 
                                            min={0}
                                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                            parser={value => value.replace(/,/g, '')}
                                        />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item name="sp_active" label="Status" valuePropName="checked">
                                        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item 
                                        name="sp_desc" 
                                        label="Description"
                                        rules={[{ max: 1500, message: "Description cannot exceed 1500 characters" }]}
                                    >
                                        <TextArea rows={4} placeholder="Enter Description" maxLength={1500} showCount />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                        <Col>
                                            <Link to="/sales/items">
                                                <Button>Cancel</Button>
                                            </Link>
                                        </Col>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                Update Sales Item
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default EditSalesItem;
